import { Button } from "@/components/ui/button";

interface NumerologyTeasersSectionProps {
  onCalculate: () => void;
}

export function NumerologyTeasersSection({ onCalculate }: NumerologyTeasersSectionProps) {
  return (
    <section className="py-16 px-6 text-center bg-gradient-to-b from-background to-muted/30">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-foreground">
          ⚠️ Seu Nome Pode Estar Bloqueando a Sua Vida
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="p-8 bg-card shadow-lg rounded-xl border border-border hover:shadow-xl transition-shadow">
            <h3 className="text-xl font-bold mb-4 text-destructive">💰 Prosperidade Travada</h3>
            <p className="text-muted-foreground leading-relaxed">
              Você trabalha duro, mas o dinheiro nunca sobra? Seu nome pode carregar <strong className="text-foreground">sequências negativas</strong> que afastam abundância e criam dívidas constantes.
            </p>
          </div>
          
          <div className="p-8 bg-card shadow-lg rounded-xl border border-border hover:shadow-xl transition-shadow">
            <h3 className="text-xl font-bold mb-4 text-destructive">🌱 Saúde em Desequilíbrio</h3>
            <p className="text-muted-foreground leading-relaxed">
              Ansiedade, cansaço ou doenças repetitivas podem estar ligadas a <strong className="text-foreground">energias ocultas no seu nome</strong> que drenam sua vitalidade e equilíbrio.
            </p>
          </div>
          
          <div className="p-8 bg-card shadow-lg rounded-xl border border-border hover:shadow-xl transition-shadow">
            <h3 className="text-xl font-bold mb-4 text-destructive">❤️ Relacionamentos Desgastados</h3>
            <p className="text-muted-foreground leading-relaxed">
              Discussões, traições ou solidão podem ser reflexo de vibrações erradas do seu nome, criando <strong className="text-foreground">padrões de repetição</strong> nos seus vínculos amorosos e familiares.
            </p>
          </div>
        </div>
        
        <Button 
          onClick={onCalculate}
          size="lg"
          className="bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 text-primary-foreground font-semibold px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all"
        >
          Ver Minha Numerologia do Nome
        </Button>
      </div>
    </section>
  );
}